import React, { useEffect } from 'react';

/**
 * Redirige a una URL externa. Se usa para que los links viejos del catálogo
 * (/catalogo, /vehiculos/...) lleven al catálogo oficial.
 */
export function ExternalRedirect({
  to
}: {
  to: string;
}) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return <main className="grid min-h-[50vh] place-items-center bg-ink px-5 text-center" data-id="element-30" data-mp="1n31ypz6wpbyl">
      <p className="text-sm text-mist" data-id="element-31" data-mp="2ate1kvnaoiib">
        Te estamos llevando al catálogo…{' '}
        <a href={to} className="font-semibold text-neon-soft underline" data-id="element-32" data-mp="2arbas9ebilcj">
          Abrir catálogo
        </a>
      </p>
    </main>;
}